require('jquery')

jQuery(function () {
  $('.slick-banner').slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    prevArrow: $('.prevBanner'),
    nextArrow: $('.nextBanner')
  })
})
